module.exports = __webpack_public_path__ + "static/media/open.5809ef64.svg";